import { format } from 'date-fns'

import { useDateStore } from '@/components/DateInput'
import { SharedDisruptionsTable } from './SharedDisruptionsTable'

import styles from './SharedDisruptions.module.scss'

export const SharedDisruptions = () => {
    const { date } = useDateStore()

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <div className={styles.details}>
                    <h1 className={styles.title}>Disruptions</h1>
                    <p className={styles.date}>{format(date, 'cccc d MMMM')}</p>
                </div>
            </header>
            <div className={styles.container}>
                <SharedDisruptionsTable />
            </div>
        </section>
    )
}
